<section class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
  <div class="tw-flex tw-justify-between lg:tw-items-center tw-w-full tw-flex-col lg:tw-flex-row tw-gap-2">
    <div class="tw-full tw-flex tw-items-center tw-gap-2">
      <h2 class="tw-gray-700 tw-font-bold tw-text-lg">Web and social presence</h2>
      <svg 
        [ngxTippy]="'Add your social media & website links to include them in email communication and landing pages'" 
        [tippyProps]="{'theme': 'dark'}" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 18C7.21997 18 5.47991 17.4722 3.99987 16.4832C2.51983 15.4943 1.36628 14.0887 0.685088 12.4442C0.00389956 10.7996 -0.17433 8.99002 0.172936 7.24419C0.520203 5.49836 1.37737 3.89471 2.63604 2.63604C3.89471 1.37737 5.49836 0.520203 7.24419 0.172936C8.99002 -0.17433 10.7996 0.00389956 12.4442 0.685088C14.0887 1.36628 15.4943 2.51983 16.4832 3.99987C17.4722 5.47991 18 7.21997 18 9C17.9974 11.3861 17.0483 13.6738 15.3611 15.3611C13.6738 17.0483 11.3861 17.9974 9 18ZM9 1.8C7.57598 1.8 6.18393 2.22228 4.9999 3.01342C3.81586 3.80457 2.89302 4.92905 2.34807 6.24468C1.80312 7.56031 1.66054 9.00799 1.93835 10.4047C2.21616 11.8013 2.9019 13.0842 3.90883 14.0912C4.91577 15.0981 6.19869 15.7838 7.59535 16.0617C8.99202 16.3395 10.4397 16.1969 11.7553 15.6519C13.071 15.107 14.1954 14.1841 14.9866 13.0001C15.7777 11.8161 16.2 10.424 16.2 9C16.1979 7.0911 15.4386 5.261 14.0888 3.9112C12.739 2.5614 10.9089 1.80215 9 1.8Z" fill="#6B7280"/><path d="M9 13.5C8.76131 13.5 8.53239 13.4052 8.36361 13.2364C8.19482 13.0676 8.1 12.8387 8.1 12.6V9H7.2C6.96131 9 6.73239 8.90518 6.56361 8.7364C6.39482 8.56762 6.3 8.3387 6.3 8.1C6.3 7.86131 6.39482 7.63239 6.56361 7.46361C6.73239 7.29482 6.96131 7.2 7.2 7.2H9C9.2387 7.2 9.46762 7.29482 9.6364 7.46361C9.80518 7.63239 9.9 7.86131 9.9 8.1V12.6C9.9 12.8387 9.80518 13.0676 9.6364 13.2364C9.46762 13.4052 9.2387 13.5 9 13.5Z" fill="#6B7280"/><path d="M10.8 13.5H7.2C6.96131 13.5 6.73239 13.4052 6.56361 13.2364C6.39482 13.0676 6.3 12.8387 6.3 12.6C6.3 12.3613 6.39482 12.1324 6.56361 11.9636C6.73239 11.7948 6.96131 11.7 7.2 11.7H10.8C11.0387 11.7 11.2676 11.7948 11.4364 11.9636C11.6052 12.1324 11.7 12.3613 11.7 12.6C11.7 12.8387 11.6052 13.0676 11.4364 13.2364C11.2676 13.4052 11.0387 13.5 10.8 13.5Z" fill="#6B7280"/><path d="M8.55 6.3C9.29559 6.3 9.9 5.69559 9.9 4.95C9.9 4.20442 9.29559 3.6 8.55 3.6C7.80442 3.6 7.2 4.20442 7.2 4.95C7.2 5.69559 7.80442 6.3 8.55 6.3Z" fill="#6B7280"/>
      </svg>
    </div>
    <div class="tw-flex tw-items-center tw-gap-3">
      @if(socialMediaCollections()?.length){
        <app-dropdown
          #socialMediaDropdown
          [heightInPX]="'200px'"
          [widthInPX]="'312px'"
          [minWidthInPX]="'312px'"
          [dropdownListXPosition]="'left'"
          [componentWithDataSetter]="socialMediaCollectionsDropdown"
          (dropdownOpened)="onOpenCollectionDropdownChange(true)"
          (dropdownClosed)="onOpenCollectionDropdownChange(false)"
        >
          <div class="tw-flex tw-gap-2 tw-items-center tw-px-2 tw-py-1 tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-all tw-duration-300">
            <span class="tw-text-gray-700 tw-text-sm tw-font-inter tw-text-nowrap">Load a collection</span>
            <i [ngClass]="{'tw-rotate-180': isPresetsCollectionsDropdownOpen()}" class="fas fa-chevron-down tw-text-xs tw-text-gray-700 tw-transition-all tw-duration-300"></i>
          </div>
        </app-dropdown>
      }
      @if(socialMediaCollections()?.length && isDataChanged() && links()?.length){
        <div class="tw-transform tw-w-[1px] tw-h-6 tw-bg-gray-200 tw-shrink-0"></div>
      }
      @if(isDataChanged() && links()?.length){
        @if(selectedCollectionIndex() != null){
          <app-dropdown
            [dropdownOptions]="updateCollectionDropdownOptions"
            [heightInPX]="'200px'"
            [widthInPX]="'312px'"
            [minWidthInPX]="'312px'"
            [dropdownListXPosition]="'left'"
            (dropdownOpened)="onOpenUpdateCollectionDropdownChange(true)"
            (dropdownClosed)="onOpenUpdateCollectionDropdownChange(false)"
            (optionClicked)="onUpdateCollectionOptionClicked($event)">
              <div class="tw-flex tw-gap-2 tw-items-center tw-px-2 tw-py-1 tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-all tw-duration-300">
                <span class="tw-text-blue-600 tw-text-sm tw-font-inter tw-text-nowrap">Save collection</span>
                <i [ngClass]="{'tw-rotate-180': isUpdateCollectionDropdownOpen()}" class="fas fa-chevron-down tw-text-xs tw-text-blue-600 tw-transition-all tw-duration-300"></i>
              </div>
          </app-dropdown>
        } @else {
          <button class="tw-text-blue-600 tw-text-sm tw-font-medium tw-font-inter tw-text-nowrap" (click)="toggleSaveAsCollectionModal()">
            Save as a collection
          </button>
        }
      }
    </div>

  </div>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-rounded-xl tw-border tw-border-gray-200 tw-p-4">
    <basic-input
      [control]="linkControl"
      [mode]="basicInputMode.INLINE"
      [allowClearButton]="false"
      placeholder="Paste url here and press Enter ↵"
      [icon]="linkEmptyIcon"
      (onKeydown)="onKeydown($event)"
      (onBlurValueChange)="createSocialLink()"
    ></basic-input>
    <div
      cdkDropList
      [cdkDropListDisabled]="links()?.length === 1"
      cdkDropListOrientation="mixed"
      cdkDropListElementContainer=".social-media-drag-list"
      (cdkDropListDropped)="drop($event)"
      [ngClass]="{'tw-pointer-events-none': isLoading()}"
      class="tw-bg-gray-50 tw-flex tw-items-center tw-flex-wrap tw-overflow-x-auto tw-rounded-lg tw-border tw-border-gray-100 tw-px-4 tw-py-3"
    >
      @if(isLoadingEvent() || isLoadingCollection()){
        <div class="empty-card tw-flex tw-flex-col tw-w-full tw-items-center tw-justify-center tw-gap-2">
          <div class="tw-w-10 tw-h-10 tw-border-4 tw-border-gray-200 tw-border-t-blue-600 tw-rounded-full tw-animate-spin"></div>
          <span class="tw-text-gray-500 tw-text-xs tw-font-medium tw-font-inter">Loading</span>
        </div>
      } @else {
        @if(links()?.length > 0){
          <div class="social-media-drag-list tw-flex tw-items-center tw-flex-1 tw-min-w-0 tw-flex-wrap gap-6">
          @for(link of links(); track $index;){
            <div
              cdkDrag
              (mousedown)="toggleDragging($index, true)"
              (touchstart)="toggleDragging($index, true)"
              (mouseup)="toggleDragging($index)"
              (touchend)="toggleDragging($index)"
              (cdkDragEnded)="toggleDragging($index)"
              class="tw-flex tw-items-center tw-flex-1 tw-gap-3 social-media-drag-item tw-relative">
  
                <app-social-media-card
                  class="tw-w-full"
                  [enableDragging]="links()?.length > 1"
                  [link]="link"
                  (updateTitle)="onUpdateTitle($index, $event)"
                  (remove)="onRemoveLink($index)"
                ></app-social-media-card>
  
                <!-- Separator - Desktop view -->
                <div 
                  [ngClass]="[(($index + 1) % 5 !== 0) && !$last ? 'md:tw-block' : 'md:tw-hidden']" 
                  class="tw-absolute tw-hidden tw-top-1/2 tw--right-3 tw-transform tw--translate-y-1/2 tw-w-[1px] tw-h-9 tw-bg-gray-300 tw-shrink-0">
                </div>
                <!-- Separator - Mobile view -->
                <div 
                  [ngClass]="[(($index + 1) % 3 !== 0) && !$last ? 'tw-block' : 'tw-hidden']" 
                  class="tw-absolute md:tw-hidden tw-top-1/2 tw--right-3 tw-transform tw--translate-y-1/2 tw-w-[1px] tw-h-9 tw-bg-gray-300 tw-shrink-0">
                </div>
            </div>
          }
          </div>
        } @else {
          <div class="empty-card tw-flex tw-flex-col tw-w-full tw-items-center tw-justify-center tw-gap-2">
            <svg class="tw-text-gray-500" xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="currentColor"><path d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5ZM480-162q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>
            <span class="tw-text-gray-500 tw-text-xs tw-font-medium tw-font-inter">No social media links added yet.</span>
          </div>
        }
      }
    </div>
  </div>

  @if (isModalOpened(saveAsCollectionModalId)) {
    <modal
      class="tw-relative"
      [id]="saveAsCollectionModalId"
      [header]="'Save a collection'"
      [headerIcon]="addIcon"
      [widthClass]="'tw-w-full tw-max-w-[564px]'"
      [heightClass]="'tw-h-auto'"
    >
      <div slot="body">
        <basic-input
          [allowClearButton]="false"
          [control]="collectionNameControl"
          label="Collection name"
          placeholder="Collection name"
          (onKeydown)="onKeydownCollectionName($event)"
        ></basic-input>
      </div>
      <div class="tw-px-6 tw-pb-6" slot="footer">
        <button
          type="button"
          [buttonSpinner]="isLoading()"
          class="tw-w-full tw-font-inter tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 tw-focus:tw-ring-4 tw-focus:tw-ring-blue-300 tw-font-medium tw-rounded-xl tw-text-base tw-px-2 tw-py-3 tw-focus:tw-outline-none"
          (click)="onSaveAsCollection()"
        >
          Save
        </button>
      </div>
    </modal>
  }

  @if (isModalOpened(renameCollectionModalId)) {
    <modal
      class="tw-relative"
      [id]="renameCollectionModalId"
      [header]="'Save a collection'"
      [headerIcon]="addIcon"
      [widthClass]="'tw-w-full tw-max-w-[564px]'"
      [heightClass]="'tw-h-auto'"
    >
      <div slot="body">
        <basic-input
          [allowClearButton]="false"
          [control]="collectionNameControl"
          label="Collection name"
          placeholder="Collection name"
          (onKeydown)="onKeydownRenameCollectionName($event)"
        ></basic-input>
      </div>
      <div class="tw-px-6 tw-pb-6" slot="footer">
        <button
          type="button"
          [buttonSpinner]="isLoading()"
          class="tw-w-full tw-font-inter tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 tw-focus:tw-ring-4 tw-focus:tw-ring-blue-300 tw-font-medium tw-rounded-xl tw-text-base tw-px-2 tw-py-3 tw-focus:tw-outline-none"
          (click)="onRenameCollection()"
        >
          Save
        </button>
      </div>
    </modal>
  }

  @if (isModalOpened(deleteCollectionModalId)) {
    <delete-modal
      message="Are you sure you want to permanently remove 
        {{socialMediaCollections()[selectedCollectionIndex() ?? 0]?.name}}?"
      [id]="deleteCollectionModalId"
      (onDelete)="confirmDeletingPresetCollection()"
      (onCancel)="cancelDeletePresetCollection()"
    ></delete-modal>
  }

</section>